import { httpClient } from "@/app/shared/shared-services/httpClient";
import { environment } from "@/environment";

const URL = environment.volunteerApiBaseUrl;

async function exportEntity(entityEndpoint, filename) {
  const url = `${URL}${entityEndpoint}`;
  const response = await httpClient.get(url, { responseType: "arraybuffer" });

  let fileURL = window.URL.createObjectURL(new Blob([response.data]));
  let fileLink = document.createElement("a");
  fileLink.href = fileURL;
  fileLink.setAttribute("download", `${filename}-${new Date().toLocaleDateString()}.csv`);
  document.body.appendChild(fileLink);
  fileLink.click();

  window.URL.revokeObjectURL(fileURL);
  fileLink.remove();
}

export default {
  async fetchAvailabilityDays(query) {
    const url = `${URL}v1/cms/volunteer-availability-days${query}`;
    return (await httpClient.get(url)).data;
  },
  async exportAvailabilityDays() {
    return await exportEntity("v1/cms/volunteer-availability-days/export", "VolunteerAvailabilityDays");
  },
  async fetchAvailabilityConfig() {
    const url = `${URL}v1/cms/volunteer-availability-config`;
    return (await httpClient.get(url)).data;
  },
  async updateAvailabilityConfig(payload) {
    const url = `${URL}v1/cms/volunteer-availability-config`;
    return (await httpClient.put(url, payload)).data;
  },
};
